import { FilmComponent } from "../FilmComponent/FilmComponent"
import { GalleryComponent2 } from "../Gallery/GalleryComponent2"
import { february2026Photos } from "../Gallery/LabPhotos/february2026/february2026Photos"
import video from "../../assets/labPhotos/february2026/video.mp4"

import "./LabText.scss"

export const February2026 = () => {
	return (
		<div className='june2025'>
			<h2 className='LabTitle'>październik - grudzień</h2>
			<p className='LabText2'></p>
			<p className='LabText2'></p>

			<GalleryComponent2
				carouselId='june2025Photos'
				images={february2026Photos}
			/>
			<FilmComponent videoPath={video} />
		</div>
	)
}
